<app-banner [banner]="banner" [isIAGModuleBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<app-left-side-menu-iag-portal [pageTitle]="pageTitle"></app-left-side-menu-iag-portal>
